import React, { Fragment } from 'react'

import {
  string,
  func,
  object,
  bool,
} from 'prop-types'

import ListLoader from 'Pods/Shared/ListLoader'
import ActionCableMessaging from 'Pods/Shared/Messaging/ActionCableMessaging'

import JobApplicant from './JobApplicant'
import JobCandidate from './JobCandidate'
import JobActions from '../../Components/JobActions'

class JobApplicants extends React.Component {
  constructor() {
    super()

    this.state = {
      data: [],
      meta: {},
      activeTabId: 'all',
      isDataFetched: false,
      activeApplicant: null,
      activeConversationId: null,
      concatData: false,
    }

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.changeStar = this.changeStar.bind(this)
    this.onChangeStarSuccess = this.onChangeStarSuccess.bind(this)
    this.renderTabButton = this.renderTabButton.bind(this)
    this.setActiveApplicant = this.setActiveApplicant.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.updateMetaInfo = this.updateMetaInfo.bind(this)
  }

  componentDidMount() {
    this.fetchData('all', 1)
  }

  fetchData(scope, page, skip, skipDataUpdate) {
    const responseFunction = skipDataUpdate ? this.updateMetaInfo : (response) => this.onFetchSuccess(response, skip)

    axios.get(`/api/internal/jobs/${this.props.id}/applicants`, { params: { scope, page } })
      .then(responseFunction)
      .catch((error) => {})
  }

  onTabClick(scope) {
    this.setState({ activeTabId: scope, concatData: false })
    this.fetchData(scope, 1)
  }

  onFetchSuccess(response, skip) {
    this.setState(prevState => ({
      data: this.state.concatData ? prevState.data.concat(response.data.data) : response.data.data,
      meta: response.data.meta,
      isDataFetched: true,
    }), () => !skip && this.setActiveApplicant(response.data.data[0]))
  }

  updateMetaInfo(response) {
    this.setState({ meta: response.data.meta })
  }

  changeStar(id) {
    axios.put(`/api/internal/job-applications/${id}/star`).then(this.onChangeStarSuccess(id))
      .catch((error) => {})
  }

  onChangeStarSuccess(id) {
    const newState = this.state

    newState.data.find(
      job => job.id === id
    ).attributes.starred = !this.state.data.find(job => job.id === id).attributes.starred

    this.setState(newState)
  }

  renderTabButton(tab) {
    const tabCounter = tab.counter > 0 ? `(${tab.counter})` : ''

    return (
      <span
        key={`tab-head-${tab.id}`}
        className={`btn btn-sm ${tab.id === this.state.activeTabId ? 'btn-primary' : 'btn-transparent'}`}
        onClick={() => { this.onTabClick(tab.id) }}
      >
        <a data-name={tab.id}>
          {`${tab.title} ${tabCounter}`}
        </a>
      </span>
    )
  }

  setActiveApplicant(newApplicant, fetch) {
    if (newApplicant) {
      this.setState({
        activeConversationId: String(newApplicant.attributes.conversationId),
        activeApplicant: newApplicant,
        concatData: false,
      })

      this.props.updateOffer(
        newApplicant.attributes.priceOffer,
        newApplicant.attributes.availableActions,
        newApplicant.id
      )
    }
    if (fetch) {
      this.fetchData(this.state.activeTabId, this.state.meta.currentPage, true, true)
    }
  }

  handlePageChange(pageNumber) {
    this.setState({ concatData: true })
    return this.fetchData(this.state.activeTabId, pageNumber, true)
  }

  render() {
    const {
      totalApplicantsCount,
      newApplicantsCount,
      starredApplicantsCount,
      pendingInvites,
    } = this.state.meta

    const tabs = [
      { id: 'all', title: 'All', counter: totalApplicantsCount },
      { id: 'new', title: 'New', counter: newApplicantsCount },
      { id: 'starred', title: 'Favorites', counter: starredApplicantsCount },
      { id: 'invited', title: 'Invited', counter: this.state.isDataFetched && pendingInvites.length || this.state.data.length },
    ]

    const showInvite = !['canceled', 'expired'].includes(this.props.jobActions.status)
    const isPublicOrPrivate = this.props.isPublicOrPrivate

    return (
      this.state.isDataFetched
        && (
        <div className="container-fixed">
          <div className="job-page__applicants row">
            <div className="col-sm-12 col-md-4 col-xl-3 applicants-column">
              <div className="card card--flat applicants-list">
                <div className="nav-tabs nav-tabs--buttons">
                  {tabs.map((tab) => this.renderTabButton(tab))}
                </div>

                {this.state.data.length > 0 || this.state.meta.pendingInvites.length > 0 ? (
                  <Fragment>
                    {this.state.data.map((applicant) => (
                      <JobApplicant
                key={applicant.id}
                applicant={applicant}
                isActive={this.state.activeApplicant && this.state.activeApplicant.id === applicant.id}
                isNew={this.state.activeTabId === 'all' && applicant.attributes.isNew}
                onChangeHeart={this.changeStar}
                updateApplicant={this.setActiveApplicant}
              />
                    ))}
                    {this.state.meta.pendingInvites.map((candidate) => (
                      <JobCandidate
                key={candidate.username}
                candidate={candidate}
              />
                    ))}
                    <ListLoader
                      totalPages={this.state.meta.totalPages}
                      currentPage={this.state.meta.currentPage}
                      onShowMore={this.handlePageChange}
                      buttonClass="btn btn-transparent btn-block btn-show-more__small-margins"
                    />
                    {showInvite && isPublicOrPrivate && (
                      <div className="applicants-list__button-wrapper">
                        <button onClick={this.props.changeTab} className="btn btn-primary">Invite more Designers</button>
                      </div>
                    )}
                  </Fragment>
                ) : (
                  showInvite ? (
                    <div className="applicants-list--empty">
                      <p>The designers are applying at the moment.</p>
                      <p>To get the best applications, you can search through the list of CGTrader 3D Designers and invite them to apply for your Project.</p>
                      <button onClick={this.props.changeTab} className="btn btn-primary btn-block">Invite Designers Now</button>
                    </div>
                  ) : (
                    <div className="applicants-list--empty">List is empty.</div>
                  )
                )}
              </div>
            </div>
            {
              this.state.activeConversationId && (
                <div className="col-sm-12 col-md-8 col-xl-9">
                  <JobActions
                    id={this.props.id}
                    availableActions={{ primary: this.state.activeApplicant.attributes.availableActions.primary, secondary: [] }}
                    applicationId={this.state.activeApplicant.id}
                    asButtons
                    isBordered
                    showOffer
                    {...this.props.jobActions}
                  />
                  <ActionCableMessaging
                    key={this.state.activeConversationId}
                    conversationId={this.state.activeConversationId}
                    conversationType="job_application"
                    isJobConversation
                  />
                </div>
              )
            }
          </div>
        </div>
        )
    )
  }
}

JobApplicants.propTypes = {
  id: string.isRequired,
  changeTab: func.isRequired,
  jobActions: object.isRequired,
  isPublicOrPrivate: bool.isRequired,
  updateOffer: func.isRequired,
}

export default JobApplicants
